// @flow
import type {
	TRootStore,
} from "../../types";

export const getSelectedLeagueId = (state: TRootStore) => state.uiSelectedLeague.selected;


// WEBPACK FOOTER //
// ./src/modules/selectors/uiSelectedLeague/index.js